import React from 'react'
import { Loader } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { selectHasRequiredAddressForValuation } from '../../../../../../redux/selectors/insertionSelectors'
import { useIsRecommendedPriceEnabled } from '../../../UseIsRecommendedPriceEnabled'
import { FairPriceNotification } from './fair-price-notification/FairPriceNotification'
import { MissingRequiredDataNotification } from './missing-required-data-notification/MissingRequiredDataNotification'
import { PriceAboveRangeNotification } from './price-above-range-notification/PriceAboveRangeNotification'

export function RecommendedPriceNotification() {
  const { t } = useTranslation()
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()
  const { minValue, maxValue, isPending } = useAppSelector((state: InitState) => state.valuationFeature)
  const { price } = useAppSelector((state: InitState) => state.insertionFeature.insertionData)
  const hasRequiredAddressData = useAppSelector(selectHasRequiredAddressForValuation)

  if (!isRecommendedPriceEnabled) {
    return null
  }

  if (isPending) {
    return (
      <div className='grid-item one-whole grid grid-flex grid-align-center gap-s'>
        <Loader size='xsmall' variant='secondary' />
        <span className='font-body-small-regular'>
          {t('wizard.screen.basicInfo.price.recommendedNotification.loading')}
        </span>
      </div>
    )
  }

  if (!hasRequiredAddressData) {
    return (
      <div className='grid-item one-whole'>
        <MissingRequiredDataNotification />
      </div>
    )
  }

  if (minValue === undefined || maxValue === undefined) {
    return null
  }

  if (price !== undefined && price > maxValue) {
    return (
      <div className='grid-item one-whole'>
        <PriceAboveRangeNotification price={price} minValue={minValue} maxValue={maxValue} />
      </div>
    )
  }

  return (
    <div className='grid-item one-whole'>
      <FairPriceNotification minValue={minValue} maxValue={maxValue} />
    </div>
  )
}
